module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "v-checkbox",
    class: {
      'checked': _vm.isChecked
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-93b9e886!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/checkbox.vue
// module id = 581
// module chunks = 2